import { createContext } from 'react';

export const SitesContext = createContext();
export const PmOverrideContext = createContext();
export const VendorListsContext = createContext();
export const FirstParentSettingsContext = createContext();
export const CategoryContext = createContext();
export const DefaultLanguageContext = createContext();
export const SelectedPrivacyManager = createContext();
export const IsApp = createContext();
export const PmContext = createContext();
export const DdmOrgsContext = createContext()